import { useApi } from './use-api-call';

export const useSearchSystemSettingApi = () =>
    useApi<{
        systemSettings: SystemSettingDTO[];
        systemSettingGroups: SystemSettingGroupDTO[];
        allowEdit: boolean;
    }>('/system-setting/search-system-setting');

export const useGetSystemSettingApi = () =>
    useApi<{ systemSetting: SystemSettingDTO; allowEdit: boolean }>(
        '/system-setting/get-system-setting/{id}'
    );

export const useSaveSystemSettingApi = () =>
    useApi<{ systemSetting: SystemSettingDTO }>('/system-setting/save-system-setting');

export const useDeleteSystemSettingApi = () => useApi('/system-setting/delete-system-setting/{id}');

export interface SystemSettingGroupDTO {
    id: string;
    title: string;
}

export interface SystemSettingDTO {
    id: string;
    value: string;
    groupId: string;
}
